import { render } from "./PlanBadgeAvatar.vue?vue&type=template&id=001c267a&scoped=true"
import script from "./PlanBadgeAvatar.vue?vue&type=script&lang=js"
export * from "./PlanBadgeAvatar.vue?vue&type=script&lang=js"

import "./PlanBadgeAvatar.vue?vue&type=style&index=0&id=001c267a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001c267a"]])

export default __exports__